export default __webpack_public_path__ + "static/media/bdswissReal03_downloadMT4.06f15313.png";